import EsusView from 'components/esus/EsusView'

export default function AtendimentoOdontologicoView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoAtendimentoOdontologico' />
}
